import React, { useEffect, useState } from 'react'
import Logo from '../tools/Logo'
import { useAddUserToRolesMutation, useGetDropDownUsersQuery, useGetUserRolesQuery, useGetUsersQuery, useUpdateUserRoleMutation } from '../../store/api/userAuthApi';
import Swal from 'sweetalert2';

const initialVlaues = {
  Id: 0,
  isAdmin: false,
  isStoreKeeper: false,
  UsersId: 0
}

const initUsers = {
  Id: 0,
  Name: ""
}

export default function UsersPrivilege() {

  const [getUserInfo, setUserInfo] = useState(initUsers)

  let [RoleInfoList, setRoleInfo] = useState([initialVlaues]);
  let [isUpdatedRole, setUpdatedRole] = useState(false);

  let [getUserId, setUserId] = useState(initUsers);
  const dataUsers = useGetDropDownUsersQuery().data;
  const [updateUserRole] = useUpdateUserRoleMutation();
  const [saveUserRole] = useAddUserToRolesMutation();
  var dropdownUsers = dataUsers ?? [];

  const handleChangeSelectUser = (e) => {
    // reset all changes from the selected previous user
    setRoleInfo([initialVlaues]);
    // make this always disabled after changing the user
    setUpdatedRole(false);
    // get the selected user id
    const selectedUserId = e.target.value;

    const selectedUser = dropdownUsers.find(user => user.id === parseInt(selectedUserId));
    const selectedUserName = selectedUser ? selectedUser.name : '';
    setUserInfo({ ...getUserInfo, Id: selectedUserId, Name: selectedUserName })
    setUserId({ ...getUserId, Id: parseInt(selectedUserId) != 'Select User' ? parseInt(selectedUserId) : 0 });
  }




  const userRoles = useGetUserRolesQuery(getUserId.Id, { pollingInterval: 1000 }).data;
  var userRolesData = userRoles ?? [];



  const handleFormChange = (index, key, value) => {

    const newData = [...RoleInfoList];

    newData[index] = {
      ...newData[index],
      //[key]: value == true? true : false,
      isStoreKeeper: key === 'isAdmin' && value == true ? false : value == true ? true : false,
      isAdmin: key === 'isStoreKeeper' && value == true ? false : value == true ? true : false,
    };
    setUpdatedRole(!isUpdatedRole);

    setRoleInfo(newData);
  };




  const getDynamicRead = () => {
    let newData = [];

    if (userRolesData.length > 0) {
      userRolesData.forEach((userRole) => {
        userRole.roles?.forEach((role) => {
          newData.push({
            Id: role.id,
            isAdmin: role.isAdmin,
            isStoreKeeper: role.isStoreKeeper,
            UsersId: role.usersId
          });
        });
      });
    } else {
      newData.push({
        Id: 0,
        isAdmin: false,
        isStoreKeeper: true,
        UsersId: 0
      });
    }

    return newData;
  };

  RoleInfoList = RoleInfoList.at(0).UsersId != "" ? RoleInfoList : getDynamicRead();



  const handleAddNewUserRole = async (e) => {
    e.preventDefault()
    let saveData = {
      Id: RoleInfoList[0].Id,
      isAdmin: RoleInfoList[0].isAdmin,
      isStoreKeeper: RoleInfoList[0].isStoreKeeper,
      UsersId: getUserId.Id
    }

    try {

      const response = await saveUserRole(saveData);
      if (response.data.status === 200) {
        Swal.fire({
          title: 'Success!',
          text: response.data.message,
          icon: 'success',
          confirmButtonText: 'Done'
        })
      } else {
        Swal.fire({
          title: 'error!',
          text: response.data.message,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }

    } catch (error) {

      console.log(error);
    }

  }



  const UpdateUserRoles = async (e) => {
    
    e.preventDefault()
    let updatedData = {
      Id: RoleInfoList[0].Id,
      isAdmin: RoleInfoList[0].isAdmin,
      isStoreKeeper: RoleInfoList[0].isStoreKeeper,
      UsersId: getUserId.Id
    }


    try {

      const response = await updateUserRole(updatedData);
      if (response.data.status === 200) {
        Swal.fire({
          title: 'Success!',
          text: response.data.message,
          icon: 'success',
          confirmButtonText: 'Done'
        })
        setRoleInfo([initialVlaues]);
        setUpdatedRole(!isUpdatedRole);

      } else {
        Swal.fire({
          title: 'error!',
          text: response.data.message,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }

    } catch (error) {

      console.log(error);
    }

  }



  return (
    <>
      <div className="block1">
        <div className="block-content block-content-full">
          <div class="block-content">
            <div className="row">
              <div className="block-header block-header-default px-5">
                <h3 className="block-title"> <Logo _width={23} name={'/icons/role1.png'} _height={22} _marginLeft={-20} /> <small className='mx-3'>Users privilege</small></h3>
              </div>

              <div className='block-content p-2'>
                <form action="">

                  <div class="row mt-2">
                    <div className="col-md-12 mt-4">
                      <div className="form-group">
                        <label>Select User To Give A Permission</label>
                        <select className="form-select rounded-2 shadow-sm1" aria-label="select example" style={{ height: '50px' }} value={getUserId.Id} onChange={handleChangeSelectUser} >
                          <option >Select User</option>
                          {
                            dropdownUsers.map((user) => {
                              return <option key={user.id} value={user.id}>{user.name}</option>
                            })
                          }

                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row p-3">
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">Role No</th>
                          <th scope="col">UserName</th>
                          <th scope="col">Admin</th>
                          <th scope="col">Store Keeper</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          userRolesData.length > 0 ?
                            userRolesData.map((user) => (
                              user.roles.map((role, index) => (
                                <tr key={role.id}>
                                  <td>{role.id}</td>
                                  <td>{user.name}</td>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={RoleInfoList[index].isAdmin === true ? true : false}
                                      onChange={(e) => handleFormChange(index, "isAdmin", e.target.checked)}
                                    />

                                  </td>
                                  <td>
                                    <input type="checkbox"
                                      checked={RoleInfoList[index].isStoreKeeper === true ? true : false}
                                      onChange={(e) => handleFormChange(index, "isStoreKeeper", e.target.checked)}
                                    />
                                  </td>
                                </tr>
                              ))
                            )) : getUserId.Id > 0 ? (<tr >

                              <td>{getUserInfo.Id}</td>
                              <td>{getUserInfo.Name}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={RoleInfoList[0].isAdmin === true ? true : false}
                                  onChange={(e) => handleFormChange(0, "isAdmin", e.target.checked)}
                                />

                              </td>
                              <td>
                                <input type="checkbox"
                                  checked={RoleInfoList[0].isStoreKeeper === true ? true : false}
                                  onChange={(e) => handleFormChange(0, "isStoreKeeper", e.target.checked)}
                                />
                              </td>
                            </tr>) : <></>}
                      </tbody>
                    </table>

                    <div className="mt-2">
                      {userRolesData.length > 0 ? (
                        <input
                          type="submit"
                          className="btn btn-primary"
                          onClick={(e) => UpdateUserRoles(e)}
                          disabled={!isUpdatedRole}
                          value="Save changes"
                        />
                      ) : getUserId.Id > 0 ? (<button className="btn btn-primary" onClick={handleAddNewUserRole}>
                        Add As New User
                      </button>) : <></>}

                    </div>
                    {/* <div class="mt-2">

                      <input
                        type="submit"
                        class="btn btn-primary "

                        onClick={(e) => UpdateUserRoles(e)}
                        disabled={isUpdatedRole}
                        value="Save changes"
                      />
                    </div> */}
                  </div>
                </form>

              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}
